import { Transition } from '@headlessui/react';

import React, { useEffect, useRef } from 'react';

function MenuSlideDown({ defaultOpen, title, icon, items }) {
  const ref = useRef(null);

  const [visible, setVisible] = React.useState(false);
  const totalHeight = items.length * 32 + 12;

  useEffect(() => {
    if (defaultOpen) {
      setVisible(true);
    }
  }, [defaultOpen]);

  const captureHeight = () =>
    ref.current && (ref.current.style.height = `${totalHeight}px`);
  const clearHeight = () => ref.current && (ref.current.style.height = '');

  return (
    <div>
      <div
        onClick={() => setVisible(($) => !$)}
        className="select-none text-content-primary flex justify-between items-center"
        aria-hidden="true"
      >
        <div className="flex gap-x-2 items-center">
          <img src={icon} className="w-4 h-4 sm:w-6 sm:h-6" alt={title} />
          <span className="font-semibold text-base leading-6">{title}</span>
        </div>
        <div>
          {visible ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m4.5 15.75 7.5-7.5 7.5 7.5"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m19.5 8.25-7.5 7.5-7.5-7.5"
              />
            </svg>
          )}
        </div>
      </div>
      <Transition
        ref={ref}
        show={visible}
        enter="transition-[height] duration-200"
        enterFrom="!h-0"
        beforeEnter={captureHeight}
        afterEnter={clearHeight}
        leave="transition-[height] duration-200"
        leaveTo="!h-0"
        beforeLeave={captureHeight}
        afterLeave={clearHeight}
        className="overflow-hidden"
      >
        <div className="h-3" />
        <ul>
          {items.map((child, childIndex) => (
            <li key={childIndex}>
              <a
                href={child.href}
                className="text-content-primary block text-base leading-8 text-content-secondary"
                target={child.external ? '_blank' : '_self'}
                rel={child.external ? 'noreferrer' : ''}
              >
                {child.name}
              </a>
            </li>
          ))}
        </ul>
      </Transition>
      <div className="h-3" />
    </div>
  );
}

export default MenuSlideDown;
